import * as bootstrap from 'bootstrap';

function toggleSidebar() {
    // Doesn't do anything yet, but a sidebar makes sense
    const body = document.querySelector('body');
    body.classList.toggle('collapse-sidebar');
}

window.mightyjs = {
    toggleSidebar
}
